<div *ngIf="config; else noPlotsData">
  <!-- <div class="visibility-toggle" (click)="toggleChartVisibility()">
    <h1 section-title>Performance Development</h1>
    <mat-icon>{{ shouldHideChart ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
  </div> -->

  <div class="toggle-container" [class.visible]="!shouldHideChart">
    <button
      mat-flat-button
      class="visibility-toggle"
      (click)="toggleChartVisibility()"
      [richTooltip]="'apc.performance_development'"
    >
      Performance Development
      <mat-icon>{{ !shouldHideChart ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
    </button>
  </div>

  <div class="chart-container" [class.visible]="!shouldHideChart">
    <div class="section section-chart">
      <div #bokehContainer [id]="chartIdWithoutHash"></div>
      <app-pd-toggle-type [config]="xAxisType" (toggleChanged)="onToggleChanged($event)"></app-pd-toggle-type>
      <!--    <br />-->
      <!--    <mat-accordion class="apc-comment">-->
      <!--      <mat-expansion-panel>-->
      <!--        <mat-expansion-panel-header>-->
      <!--          <mat-panel-title>Comment</mat-panel-title>-->
      <!--        </mat-expansion-panel-header>-->
      <!--              <textarea matInput rows="8" [(ngModel)]="performanceDevelopmentComment" (ngModelChange)="processComment()"></textarea>-->
      <!--      </mat-expansion-panel>-->
      <!--    </mat-accordion>-->
    </div>
  </div>
</div>

<ng-template #noPlotsData>
  <h1>There is not plots data</h1>
</ng-template>
